<template>
  <div class="list-amenities">
    <SidebarLayout2 :breadcrumb="breadcrumb" pageTitle="Amenidades">
      <!-- Sidebar -->
      <template #sidebar>
        <div class="sidebar-title">
          <Heading element="h2">
            Ações da página
          </Heading>
        </div>
        <!-- Botões -->
        <div class="buttons">
          <!-- Botão criar -->
          <Button
            :hasIcon="true"
            class="buttons--create"
            data-cy="create-amenity"
            @click="$router.push({ path: '/amenidades/nova' })"
            >Criar amenidade</Button
          >
          <!-- Botão editar -->
          <Button
            :disabled="disabledEditButton"
            class="buttons--edit"
            @click="
              $router.push({
                path: `amenidades/editar/${selectedRows[0].codigo}`
              })
            "
            >Editar</Button
          >
          <!-- Botão desativar -->
          <Button
            v-show="showInactivateButton"
            :disabled="selectedRows.length < 1"
            variation="error"
            class="buttons--delete"
            data-cy="delete-amenity"
            @click="showModal = true"
            >Desativar</Button
          >
          <!-- Botão reativar -->
          <Button v-show="showReactivateButton" @click="reactivateAmenity()"
            >Reativar</Button
          >
        </div>
      </template>
      <!-- Conteúdo principal -->
      <template #content>
        <div class="filters">
          <!-- Busca por nome -->
          <SearchInput
            v-model="searchByName"
            data-cy="search-amenity"
            class="filters--search"
          />
          <!-- Filtro de status -->
          <FilterDropdown
            v-model="statusFilter"
            :options="filterOptions"
            data-cy="filter-amenity"
            class="filters--dropdown"
          />
        </div>
        <!-- Tabela -->
        <DataTable
          :cols="cols"
          :colsMinWidths="colsMinWidths"
          :isLoading="false"
          :rows="rows"
          :selectableRow="true"
          ref="dataTable"
          class="table"
          @getSelectedRows="selectedRows = $event"
        >
          <template v-slot:ativo="data">
            {{ data.rowDataObj.ativo ? 'Ativo' : 'Inativo' }}
          </template>
          <template v-slot:acoes="data">
            <button
              class="table--action"
              data-cy="edit-amenity"
              @click.stop.prevent="
                $router.push({
                  path: `amenidades/editar/${data.rowDataObj.codigo}`
                })
              "
            >
              Editar
            </button>
          </template>
          <template v-slot:excluir="slotProps">
            <button
              class="table--action table--action__delete"
              data-cy="delete-amenity"
              @click.stop.prevent="deleteModal(slotProps.rowDataObj.codigo)"
            >
              Excluir
            </button>
          </template>
        </DataTable>
        <!-- Paginação -->
        <PmwPagination
          :currentPage="pagination.currentPage"
          :items="filterAmenities"
          :itemsPerPage="pagination.itemsPerPage"
          :itemsPerPageOptions="pagination.itemsPerPageOptions"
          :totalItems="filterAmenities.length"
          @changePagination="changePagination"
        />
      </template>
    </SidebarLayout2>
    <!-- Modal de deleção -->
    <AlertModal
      v-model="showModal"
      :buttonClose="true"
      title="Desativar amenidade"
      @alert-modal-confirm="inactivateAmenities"
    >
      <template #text>
        Ao desativar essa amenidade, ela não será <br />
        mais listada nos hotéis/quartos que a utilizem. <br />
        Tem certeza de que quer fazer isso?
      </template>
    </AlertModal>
  </div>
</template>

<script>
import { removeStringAccents } from '@/helpers/string.js'

import AlertModal from '@solucoes/components-lib-tmp/src/components/patterns/AlertModal'
import Button from '@solucoes/components-lib-tmp/src/components/elements/Button'
import DataTable from '@solucoes/components-lib-tmp/src/components/patterns/DataTable'
import FilterDropdown from '@solucoes/components-lib-tmp/src/components/patterns/FilterDropdown'
import Heading from '@solucoes/components-lib-tmp/src/components/elements/Heading'
import PmwPagination from '@solucoes/components-lib-tmp/src/components/patterns/PmwPagination'
import SearchInput from '@solucoes/components-lib-tmp/src/components/elements/SearchInput'
import SidebarLayout2 from '@/layouts/SidebarLayout2'

export default {
  name: 'ListAmenities',
  components: {
    AlertModal,
    Button,
    DataTable,
    FilterDropdown,
    Heading,
    PmwPagination,
    SearchInput,
    SidebarLayout2
  },
  data() {
    return {
      /** Array com todas as amenidades */
      allItems: [],
      /** Caminho de pão */
      breadcrumb: [
        {
          label: 'Configurações'
        },
        {
          label: 'Amenidades',
          url: '/'
        }
      ],
      /** Colunas da tabela */
      cols: [
        {
          name: 'amenidade',
          alias: 'Amenidade'
        },
        {
          name: 'ativo',
          alias: 'Status'
        },
        {
          name: 'acoes',
          alias: 'Ações'
        },
        {
          name: 'excluir'
        }
      ],
      /** Tamanho mínimo das colunas */
      colsMinWidths: {
        amenidade: '500px',
        ativo: '130px',
        acoes: '70px',
        excluir: '70px'
      },
      /** Opções de status para o filtro */
      filterOptions: [
        {
          label: 'Todos',
          value: -1
        },
        {
          label: 'Ativo',
          value: 1,
          checked: true
        },
        {
          label: 'Inativo',
          value: 0
        }
      ],
      oneSelectedRow: [],
      /** Dados para paginação */
      pagination: {
        currentPage: 1,
        itemsPerPage: 25,
        itemsPerPageOptions: [
          {
            text: '25',
            value: 25
          },
          {
            text: '50',
            value: 50
          },
          {
            text: '100',
            value: 100
          }
        ]
      },
      /** Linhas da tabela (dados)  */
      rows: [],
      /** v-model da busca por nome */
      searchByName: '',
      /** Array das linhas selecionadas */
      selectedRows: [],
      /** Visualização da modal */
      showModal: false,
      /** v-model do filtro por status */
      statusFilter: {
        label: 'Ativo',
        value: 1
      }
    }
  },
  computed: {
    disabledEditButton() {
      /** Habilitação do botão de editar */
      if (this.selectedRows.length === 1) {
        return false
      }
      return true
    },
    filterAmenities() {
      /** Carrega a tabela de acordo com os valores dos filtros (nome e status) */
      return this.allItems.reduce((acc, curr) => {
        let match = true

        /** Filtra por status */
        match =
          +curr.data.ativo === +this.statusFilter.value ||
          +this.statusFilter.value === -1

        if (match) {
          acc.push(curr)
        }
        /** Filtra por nome */
        const results = acc.filter(
          (data) =>
            removeStringAccents(data.data.amenidade)
              .toLowerCase()
              .indexOf(removeStringAccents(this.searchByName).toLowerCase()) >
            -1
        )

        return results
      }, [])
    },
    showInactivateButton() {
      /** Exibição do botão de inativar */
      const isActive = this.selectedRows.some((item) => {
        return !item.ativo
      })
      if (!isActive) {
        return true
      }
      return false
    },
    showReactivateButton() {
      /** Exibição do botão de reativar amenidade */
      if (this.selectedRows.length === 1 && !this.selectedRows[0].ativo) {
        return true
      }
      return false
    }
  },
  watch: {
    filterAmenities(newVal) {
      if (newVal) {
        this.clearSelectedRows()
      }
    }
  },
  created() {
    this.getAmenities()
  },
  methods: {
    changePagination(childData) {
      /** Dados da tabela conforme a paginação */
      this.pagination.currentPage = childData.currentPage
      this.rows = childData.items
    },
    clearSelectedRows() {
      /** Limpa as linhas selecionadas */

      this.oneSelectedRow = []
      this.$refs.dataTable.selectAllRows()
    },
    deleteModal(id) {
      this.showModal = true
      if (id) {
        this.oneSelectedRow.push(id)
      }
    },
    getAmenities() {
      /** Retorna os itens para popular a tabela */
      this.$amenities.getAmenities().then((response) => {
        this.allItems = this.standarizeRowsData(response.data)
      })
    },
    inactivateAmenities() {
      /** Desativa amenidades */
      let ids = null
      /** Se for exclusão pelo botão da sidebar */
      if (this.oneSelectedRow.length === 0) {
        ids = this.selectedRows.map((item) => {
          return item.codigo
        })
        /** Se for exclusão pela coluna da tabela */
      } else {
        ids = this.oneSelectedRow
      }

      this.$amenities
        .inactivateAmenities(ids)
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Amenidade(s) inativada(s)'
          })
          this.getAmenities()
          this.clearSelectedRows()
          this.searchByName = ''
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Erro ao inativar amenidade(s)'
          })
        })
    },
    reactivateAmenity() {
      /** Reativa uma amenidade */
      const ids = this.selectedRows[0].codigo
      const idiomas = this.selectedRows[0].idiomas
      this.$amenities
        .updateAmenity({
          codigo: ids,
          ativo: true,
          idiomas: idiomas
        })
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Amenidade reativada'
          })
          this.selectedRows[0].ativo = true
        })
        .catch((error) => {
          this.$bus.$emit('show-alert-chip', {
            message: error.messages[0]
          })
        })
    },
    standarizeRowsData(data) {
      /** Padroniza os dados para popular a tabela */
      const array = []
      let nome = ''

      data.forEach((item) => {
        /** Encontra o nome da amenidade em português */
        const index = item.idiomas.findIndex((langItem) => {
          return langItem.idioma === 'pt-BR'
        })

        nome = item.idiomas[index].nome

        array.push({
          data: {
            amenidade: nome,
            codigo: item.codigo,
            ativo: item.ativo,
            idiomas: item.idiomas
          }
        })
      })

      /** Retorna o array com os dados em ordem alfabética */
      return array.sort((a, b) => {
        const firstItem = removeStringAccents(a.data.amenidade).toLowerCase()
        const nextItem = removeStringAccents(b.data.amenidade).toLowerCase()
        if (firstItem > nextItem) {
          return 1
        } else if (firstItem < nextItem) {
          return -1
        } else {
          return 0
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .lb-breadcrumb--link:nth-child(2) {
  cursor: default;
}
::v-deep .table {
  margin-bottom: 0;
}
::v-deep .content {
  .page-heading {
    padding-bottom: 24px;
  }
}
::v-deep .datable-grid-wrapper {
  .col {
    padding-left: 14px;
  }
}
::v-deep .pmw-datatable-wrapper__overflow {
  max-height: none;

  .pmw-col.pmw-th:nth-child(4),
  .pmw-col.pmw-td:nth-child(4) {
    max-width: 80px;
  }
  .pmw-col.pmw-th:nth-child(4) {
    border-right: none;
  }
  .pmw-col.pmw-th:nth-child(5),
  .pmw-col.pmw-td:nth-child(5) {
    max-width: 70px;
  }
  .pmw-col.pmw-th:nth-child(4),
  .pmw-col.pmw-th:nth-child(5) {
    pointer-events: none;
    .pmw-sort-icons {
      display: none;
    }
  }
  .pmw-col.pmw-th:nth-child(3),
  .pmw-col.pmw-td:nth-child(3) {
    max-width: 130px;
  }
}

.sidebar-title {
  padding-top: 35px;
  margin-left: 20px;
  margin-bottom: 15px;
}
.buttons {
  width: 215px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: auto;
}
.filters {
  &--search {
    width: 215px;
    margin-bottom: 15px;
  }
  &--dropdown {
    margin-bottom: 30px;
  }
}
.table {
  &--action {
    border: none;
    background-color: inherit;
    color: $blue;
    font-weight: font-weight('weight-medium');
    &__delete {
      color: $error;
    }
  }
}
</style>
